import classNames from 'classnames';
import React from 'react';
import { CheckPickerProps } from 'rsuite/lib/CheckPicker';
import CheckPill from './CheckPill';
import styles from './CheckPillWithIconProps.module.scss';

type CheckPillWithIconProps = CheckPickerProps & {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
};

const CheckPillWithIcon = ({ className, startIcon, endIcon, value, ...props }: CheckPillWithIconProps) => {
  const hasValue = !!value?.length;

  return (
    <div className={classNames(styles.wrapper, hasValue && styles['wrapper--has-value'])}>
      {!hasValue && startIcon && <span className={classNames(styles.icon, styles['start-icon'])}>{startIcon}</span>}
      <CheckPill className={classNames(styles['check-pill'], className)} value={value} {...props} />
      {endIcon && <span className={classNames(styles.icon, styles['end-icon'])}>{endIcon}</span>}
    </div>
  );
};

export default CheckPillWithIcon;
